import React from 'react';

interface SwitchProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Switch: React.FC<SwitchProps> = ({ checked, onChange }) => {
  return (
    <div className="relative inline-block w-12">
      {/* Hidden checkbox input */}
      <input
        type="checkbox"
        name="toggle"
        id="toggle"
        checked={checked}
        onChange={onChange}
        className="sr-only"
      />
      {/* Background of the switch */}
      <div
        className={`block w-[38px] h-4 rounded-full transition-colors ${
          checked ? 'bg-[#023f81]' : 'bg-gray-300'
        }`}
      />
      {/* The sliding circle */}
      <span
        onClick={() =>
          onChange({
            target: { checked: !checked },
          } as React.ChangeEvent<HTMLInputElement>)
        }
        className={`absolute top-0.5 left-0.1 w-3 h-3 rounded-full bg-white cursor-pointer transition-transform ${
          checked ? 'translate-x-6' : ''
        }`}
      />
    </div>
  );
};

export default Switch;
